import * as React from 'react';
import ErrorLayoutHeader from './ErrorLayoutHeader';

interface Properties {
    children?: React.ReactNode;
}

const ErrorLayout: React.FC<Properties> = ({ children }) => (
    <>
        <ErrorLayoutHeader />
        <div style={{ textAlign: 'center' }}>{children}</div>
    </>
);

export default ErrorLayout;
